<script>
import _get from 'lodash-es/get'

export default {
  props: {
    student: {
      required: true,
      type: Object
    },

    lastFirst: {
      type: Boolean,
      default: false
    }
  },

  render() {
    return this.$scopedSlots.default({
      display: this.display
    })
  },

  computed: {
    first() {
      return _get(this, 'student.first')
    },

    firstLast() {
      return this.first + ' ' + this.last
    },

    hasBothFirstAndLast() {
      return this.first && this.last
    },

    last() {
      return _get(this, 'student.last')
    },

    lastCommaFirst() {
      return this.last + ', ' + this.first
    },

    display() {
      if (this.hasBothFirstAndLast && this.lastFirst) {
        return this.lastCommaFirst
      } else if (this.hasBothFirstAndLast) {
        return this.firstLast
      } else if (this.last) {
        return this.last
      } else if (this.first) {
        return this.first
      } else {
        return 'unnamed student'
      }
    }
  }
}
</script>
